<template>
    <div class="whatsapp-body">
        <a href="https://web.whatsapp.com/send?phone=8618126135449&text=Hi%2C%20could%20you%20please%20send%20me%20the%20PDF%20catalog%3F" target="_blank" rel="noopener noreferrer" >
            <img src="@/assets/images/WhatsApp.png" alt="">
        </a>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="less" scoped>
    .whatsapp-body{
        position: fixed;
        right: 20px;
        bottom: 50px;
        z-index: 999;
        width: 54px;
        height: 54px;
        a{
            img{
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }
    }
</style>